import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Contacto() {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    empresa: '',
    anexo: '',
    assunto: '',
    mensagem: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [selectedFiles, setSelectedFiles] = useState<FileList | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedFiles(e.target.files);
    }
  };

  const removeFile = (index: number) => {
    if (selectedFiles) {
      const dt = new DataTransfer();
      for (let i = 0; i < selectedFiles.length; i++) {
        if (i !== index) {
          dt.items.add(selectedFiles[i]);
        }
      }
      setSelectedFiles(dt.files.length > 0 ? dt.files : null);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      
      // Adicionar todos os campos do formulário
      formBody.append('nome', formData.nome);
      formBody.append('email', formData.email);
      formBody.append('telefone', formData.telefone);
      formBody.append('empresa', formData.empresa || 'Não informado');
      formBody.append('assunto', formData.assunto);
      formBody.append('mensagem', formData.mensagem);

      // Adicionar informações de anexos
      if (selectedFiles && selectedFiles.length > 0) {
        const fileInfo = Array.from(selectedFiles)
          .map(file => `${file.name} (${(file.size / 1024).toFixed(1)} KB)`)
          .join(', ');
        formBody.append('anexos', fileInfo);
      } else {
        formBody.append('anexos', 'Nenhum ficheiro anexado');
      }

      const response = await fetch('https://readdy.ai/api/form/d4n7ak9btbscp07qba60', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nome: '',
          email: '',
          telefone: '',
          empresa: '',
          anexo: '',
          assunto: '',
          mensagem: '',
        });
        setSelectedFiles(null);
        
        // Limpar o input de arquivo
        const fileInput = document.getElementById('anexo') as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Erro ao enviar formulário:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const faqs = [
    {
      question: 'Qual o tempo médio de resposta?',
      answer: 'O nosso tempo médio de resposta dependerá conforme a complexidade da solicitação.',
    },
    {
      question: 'Como funciona a consultoria inicial?',
      answer: 'A consultoria inicia-se com uma análise preliminar da sua necessidade, seguida de uma reunião de enquadramento e apresentação de proposta personalizada.',
    },
    {
      question: 'Atendem empresas de todos os portes?',
      answer: 'Sim. Trabalhamos com micro, pequenas, médias e grandes organizações, ajustando as soluções à realidade e maturidade de cada cliente.',
    },
    {
      question: 'Qual a área de actuação geográfica?',
      answer: 'Actuamos principalmente em Angola, com possibilidade de projectos e parcerias em contexto internacional.',
    },
  ];

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#CB9832]/5 via-white to-[#CB9832]/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <nav className="text-sm text-gray-600 mb-6">
            <a href="/" className="hover:text-[#CB9832] cursor-pointer">Início</a>
            <span className="mx-2">&gt;</span>
            <span className="text-[#CB9832]">Contacto</span>
          </nav>
          <h1 className="text-5xl md:text-6xl font-bold text-black mb-6">FALE CONNOSCO</h1>
          <p className="text-xl md:text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Estamos preparados para apoiar a sua organização na construção de soluções sustentáveis, estratégicas e orientadas a resultados.
          </p>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-10 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-customer-service-2-line',
                title: 'Atendimento',
                info: '+244 921 567 602',
                subinfo: 'Seg. a Sex., das 8h às 17h',
              },
              {
                icon: 'ri-mail-send-line',
                title: 'E-mail',
                info: 'info@maiskudima.com',
                subinfo: 'Canal directo para solicitações institucionais, parcerias e propostas.',
              },
              {
                icon: 'ri-map-pin-line',
                title: 'Endereço',
                info: 'Rua Eduardo Mondlane, Nº 210',
                subinfo: 'Maianga, Luanda - Angola',
              },
            ].map((contact, index) => (
              <div key={index} className="bg-[#F8F8F8] rounded-2xl p-8 text-center hover:shadow-xl transition-all group cursor-pointer">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-[#2D5F3F] rounded-full group-hover:scale-110 transition-transform">
                  <i className={`${contact.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-black mb-2">{contact.title}</h3>
                <p className="text-lg text-[#2D5F3F] font-semibold mb-1">{contact.info}</p>
                <p className="text-sm text-gray-600">{contact.subinfo}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Main Contact Section */}
      <section className="py-10 bg-[#F8F8F8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
            {/* Form - 60% */}
            <div className="lg:col-span-3">
              <div className="bg-white rounded-3xl p-8 shadow-xl">
                <h2 className="text-3xl font-bold text-black mb-3">FORMULÁRIO – CONTACTE-NOS</h2>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Utilize o formulário abaixo para nos contactar. A nossa equipa analisará a sua solicitação e responderá com brevidade.
                </p>
                <form id="contato-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="nome" className="block text-gray-700 font-medium mb-2">
                        Nome Completo *
                      </label>
                      <input
                        type="text"
                        id="nome"
                        name="nome"
                        value={formData.nome}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-[#CB9832] focus:outline-none transition-colors"
                        placeholder="Seu nome"
                      />
                    </div>

                    <div>
                      <label htmlFor="email" className="block text-gray-700 font-medium mb-2">
                        E-mail *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-[#CB9832] focus:outline-none transition-colors"
                        placeholder="Adicione o seu E-mail"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="telefone" className="block text-gray-700 font-medium mb-2">
                        Telefone *
                      </label>
                      <input
                        type="tel"
                        id="telefone"
                        name="telefone"
                        value={formData.telefone}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-[#CB9832] focus:outline-none transition-colors"
                        placeholder="(+244) 900 000 000"
                      />
                    </div>

                    <div>
                      <label htmlFor="empresa" className="block text-gray-700 font-medium mb-2">
                        Empresa
                      </label>
                      <input
                        type="text"
                        id="empresa"
                        name="empresa"
                        value={formData.empresa}
                        onChange={handleChange}
                        className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-[#CB9832] focus:outline-none transition-colors"
                        placeholder="Nome da empresa"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="assunto" className="block text-gray-700 font-medium mb-2">
                      Assunto *
                    </label>
                    <select
                      id="assunto"
                      name="assunto"
                      value={formData.assunto}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-[#CB9832] focus:outline-none transition-colors"
                    >
                      <option value="">Selecione um assunto</option>
                      <option value="consultoria">Consultoria Estratégica</option>
                      <option value="formacao">Formação</option>
                      <option value="gestao-projectos">Gestão de Projectos</option>
                      <option value="eventos">Eventos</option>
                      <option value="parceria">Parceria</option>
                      <option value="outros">Outros</option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="anexo" className="block text-gray-700 font-medium mb-2">
                      Anexos
                    </label>
                    <div className="relative">
                      <input
                        type="file"
                        id="anexo"
                        name="anexo"
                        onChange={handleFileChange}
                        multiple
                        className="hidden"
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
                      />
                      <label
                        htmlFor="anexo"
                        className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 bg-white hover:bg-gray-50 text-gray-700 text-center cursor-pointer transition-colors flex items-center justify-center gap-2"
                      >
                        <i className="ri-attachment-line text-xl"></i>
                        <span>Clique para selecionar ficheiros</span>
                      </label>
                    </div>
                    {selectedFiles && selectedFiles.length > 0 && (
                      <div className="mt-3 space-y-2">
                        {Array.from(selectedFiles).map((file, index) => (
                          <div
                            key={index}
                            className="flex items-center justify-between bg-gray-50 px-4 py-2 rounded-lg border border-gray-200"
                          >
                            <div className="flex items-center gap-2 flex-1 min-w-0">
                              <i className="ri-file-line text-[#CB9832]"></i>
                              <span className="text-sm text-gray-700 truncate">{file.name}</span>
                              <span className="text-xs text-gray-500">
                                ({(file.size / 1024).toFixed(1)} KB)
                              </span>
                            </div>
                            <button
                              type="button"
                              onClick={() => removeFile(index)}
                              className="ml-2 w-6 h-6 flex items-center justify-center text-red-500 hover:bg-red-50 rounded cursor-pointer transition-colors"
                              aria-label="Remover ficheiro"
                            >
                              <i className="ri-close-line"></i>
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                    <p className="text-sm text-gray-500 mt-1">
                      Formatos aceites: PDF, DOC, DOCX, XLS, XLSX, JPG, PNG
                    </p>
                  </div>

                  <div>
                    <label htmlFor="mensagem" className="block text-gray-700 font-medium mb-2">
                      Mensagem *
                    </label>
                    <textarea
                      id="mensagem"
                      name="mensagem"
                      value={formData.mensagem}
                      onChange={handleChange}
                      required
                      maxLength={500}
                      rows={6}
                      className="w-full px-4 py-3 rounded-lg border-2 border-gray-200 focus:border-[#CB9832] focus:outline-none transition-colors resize-none"
                      placeholder="Descreva brevemente a sua necessidade, desafio ou proposta de colaboração."
                    ></textarea>
                    <p className="text-sm text-gray-500 mt-1">Máximo de 500 caracteres</p>
                  </div>

                  {submitStatus === 'success' && (
                    <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg">
                      <i className="ri-checkbox-circle-line mr-2"></i>
                      Mensagem enviada com sucesso! Entraremos em contacto em breve.
                    </div>
                  )}

                  {submitStatus === 'error' && (
                    <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg">
                      <i className="ri-error-warning-line mr-2"></i>
                      Erro ao enviar mensagem. Por favor, tente novamente.
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full bg-[#2D5F3F] text-white px-6 py-4 rounded-lg font-bold text-lg hover:bg-[#234A32] transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {isSubmitting ? (
                      <>
                        <i className="ri-loader-4-line animate-spin mr-2"></i>
                        Enviando...
                      </>
                    ) : (
                      <>
                        Submeter Pedido
                        <i className="ri-send-plane-fill ml-2"></i>
                      </>
                    )}
                  </button>
                </form>
                <div className="bg-[#F8F8F8] border-l-4 border-[#CB9832] p-4 mt-6 rounded-lg">
                  <p className="text-base text-gray-700 leading-relaxed">
                    A +Kudima actua com foco em impacto, credibilidade e excelência na entrega de soluções corporativas sustentáveis.
                  </p>
                </div>
              </div>
            </div>

            {/* Additional Info - 40% */}
            <div className="lg:col-span-2 space-y-8">
              {/* RENÚNCIA DE RESPONSABILIDADE */}
              <div id="faq" className="bg-white rounded-3xl p-8 shadow-xl">
                <h3 className="text-2xl font-bold text-black mb-6">Perguntas Frequentes</h3>
                <div className="space-y-4">
                  {faqs.map((faq, index) => (
                    <div key={index} className="border-b border-gray-200 pb-4">
                      <button
                        onClick={() => setOpenFaq(openFaq === index ? null : index)}
                        className="w-full flex items-center justify-between text-left cursor-pointer group"
                      >
                        <span className="font-semibold text-gray-900 group-hover:text-[#CB9832] transition-colors">
                          {faq.question}
                        </span>
                        <i
                          className={`ri-arrow-down-s-line text-xl text-[#CB9832] transition-transform ${
                            openFaq === index ? 'rotate-180' : ''
                          }`}
                        ></i>
                      </button>
                      {openFaq === index && (
                        <p className="mt-3 text-gray-600 leading-relaxed">{faq.answer}</p>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="bg-white rounded-3xl p-8 shadow-xl">
                <h3 className="text-lg text-gray-700 mb-6 leading-relaxed">Acompanhe a +Kudima nas redes sociais e esteja a par dos nossos projectos, iniciativas e conteúdos estratégicos.</h3>
                <div className="grid grid-cols-2 gap-4">
                  <a
                    href="https://linkedin.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 bg-[#0077B5] text-white px-4 py-3 rounded-lg hover:opacity-90 transition-opacity cursor-pointer"
                  >
                    <i className="ri-linkedin-fill text-xl"></i>
                    LinkedIn
                  </a>
                  <a
                    href="https://instagram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 bg-gradient-to-r from-[#833AB4] via-[#FD1D1D] to-[#F77737] text-white px-4 py-3 rounded-lg hover:opacity-90 transition-opacity cursor-pointer"
                  >
                    <i className="ri-instagram-line text-xl"></i>
                    Instagram
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gray-200 rounded-3xl overflow-hidden shadow-xl" style={{ height: '500px' }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3942.4!2d13.234!3d-8.815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOMKwNDgnNTQuMCJTIDEzwrAxNCcwMi40IkU!5e0!3m2!1spt-PT!2sao!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização Kudima - Rua Eduardo Mondlane, Nº 210, Maianga, Luanda"
            ></iframe>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
